module.exports = __webpack_public_path__ + "img/icone-highres.f4cf105a.svg";